import surpriseBoxSlice from './reducer'
import saga from './saga'
import * as selectors from './selectors'
import * as actions from './actions'

const reducer = surpriseBoxSlice.reducer

export { reducer, saga, selectors, actions }
